module.exports = __webpack_public_path__ + "static/media/app-bar-save.36356e08.svg";